/* eslint-disable no-unused-vars, consistent-return, no-unused-vars, no-restricted-syntax, class-methods-use-this, strict */

class Barba {
  constructor() {
    window.previouslyLoadedScripts = [];
    this.init();
  }

  init() {
    if (window.ie) {
      return;
    }

    import(/* webpackChunkName: "library-barba" */ "@barba/core").then(
      ({ default: barba }) => {
        this.loadBarba(barba);
      }
    );
  }

  loadBarba(barba) {
    const htmlDocument = document.getElementsByTagName("html")[0];
    const transitionDuration = 800;

    barba.init({
      debug: false,
      cacheIgnore: false,
      prefetchIgnore: false,
      timeout: 5000,
      transitions: [
        {
          name: "default",
          beforeLeave() {
            const async = this.async();

            // Block scroll
            document.body.classList.add("u-mobile-block-scroll");

            // Show transition
            htmlDocument.classList.add("barba-is-leaving");

            setTimeout(() => {
              async();
            }, transitionDuration);
          },
          afterLeave() {
            // Scroll to top
            htmlDocument.style.scrollBehavior = "auto";
            htmlDocument.scrollIntoView({
              block: "start",
              behavior: "auto",
            });
          },
          enter() {
            // Show new view
            htmlDocument.classList.remove("barba-is-leaving");

            // Unlock scroll
            htmlDocument.style.scrollBehavior = "smooth";
            document.body.classList.remove("u-mobile-block-scroll"); // Remove scroll block
          },
        },
      ],
      prevent: ({ el }) => {
        const ignoreClasses = ["ab-item", "another-class-here"]; // Additional (besides .js-barba-prevent) ignore links with these classes (ab-item is for wp admin toolbar links)
        if (/.pdf/.test(el.href.toLowerCase())) {
          return true;
        }
        if (el.classList && el.classList.contains("js-barba-prevent")) {
          return true;
        }
        if (el.dataset && el.dataset.lightbox) {
          return true;
        }
        for (let i = 0; i < ignoreClasses.length; i += 1) {
          if (el.classList.contains(ignoreClasses[i])) {
            return true;
          }
        }
      },
      requestError: (trigger, action, url, response) => {
        console.error("REQUEST ERROR"); // eslint-disable-line no-console
        console.error(url); // eslint-disable-line no-console
        console.error(response); // eslint-disable-line no-console
      },
    });

    // Global enter hook
    barba.hooks.enter(({ current, next, trigger }) => {
      window.requestAnimationFrame(() => {
        this.jumpToAnchor();
        this.setBodyClasses(next);
        this.setTranslationLinks(next.container);
        this.mobileMenu();
        this.updateCurrentHighlightedMenu(next.html);
        window.destroyScrollMagicScenes();

        // Modules
        window.modulesLoader.loadModules();

        // Link anchor
        this.triggerLinkAnchor();

        // Wysiwyg
        this.fixWysiwyg();

        // Trigger location change event
        window.dispatchEvent(new Event("locationchange"));

        // Animations
        import(
          /* webpackChunkName: "library-scrollmagic" */ "scrollmagic"
        ).then(({ default: ScrollMagic }) => {
          setTimeout(() => {
            window.setAnimationScenes(new ScrollMagic.Controller());
          }, transitionDuration);
        });

        // WP admin bar
        this.fixWpAdminBar();
      });
    });

    barba.hooks.after((data) => {
      this.getStylesAndScripts(data, () => {
        this.domReloadEvents();
      });
    });
  }

  jumpToAnchor() {
    if (window.location.hash !== "") {
      if (document.readyState === "complete") {
        setTimeout(() => {
          this.jumpToAnchorDelayed();
        }, 100);
      } else {
        document.onreadystatechange = () => {
          if (document.readyState === "complete") {
            this.jumpToAnchor();
          }
        };
      }
    } else {
      window.scrollTo(0, 0);
    }
  }

  jumpToAnchorDelayed() {
    if (window.location.hash !== "") {
      let id = window.location.hash;

      if (id.indexOf("?") !== -1) {
        id = id.substr(0, id.indexOf("?"));
      }

      let scrollY = 0;
      let scrollTo = 0;
      if (document.querySelector(id)) {
        scrollY = Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        );
        scrollTo =
          document.querySelector(id).getBoundingClientRect().top + scrollY;
      }
      window.scrollTo(0, scrollTo);
    } else {
      window.scrollTo(0, 0);
    }
  }

  setBodyClasses(next) {
    const matches = next.html.match(/<body.+?class="([^""]*)"/i);
    document.body.setAttribute("class", (matches && matches.at(1)) ?? "");
  }

  setTranslationLinks(e) {
    "use strict";

    const linksData = e.getAttribute("data-translation-links");

    if (linksData && linksData !== "null") {
      const links = JSON.parse(linksData);

      if (links.constructor === Array && links.length > 0) {
        for (let s = 0; s < links.length; s += 1) {
          const li = document.querySelector(
            `.header__languages ul li:nth-child( ${s + 1}) a`
          );

          if (li !== null) {
            li.setAttribute("href", links[s]);
          }
        }
      }
    }
  }

  mobileMenu() {
    const mobileMenuToogler = document.getElementById("main-menu-toggler");

    if (mobileMenuToogler) {
      mobileMenuToogler.checked = false;
    }
  }

  /**
   * Parses the DOM structure of the BarbaJS fetch, and applies same classes on the header in DOM.
   * @param {String} htmlString - The new page html in string format from barbaJs
   */
  updateCurrentHighlightedMenu(htmlString) {
    const html = new window.DOMParser().parseFromString(
      htmlString,
      "text/html"
    );

    if ("body" in html === false || html.body.childNodes.length < 1) {
      // Why the length check?
      return;
    }

    // First remove current classes from all menu items and sub menus.
    for (const el of Array.from(document.querySelectorAll(".menu-item"))) {
      el.classList.remove("current-menu-item");
      el.classList.remove("current-menu-parent");
      el.classList.remove("current-menu-ancestor");
    }

    // Get the new current menu items and parents and set the appropiate classes.
    let newEl;

    for (const el of Array.from(html.querySelectorAll(".current-menu-item"))) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.add("current-menu-item");
        }
      }
    }

    for (const el of Array.from(
      html.querySelectorAll(".current-menu-parent")
    )) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.add("current-menu-parent");
        }
      }
    }

    for (const el of Array.from(
      html.querySelectorAll(".current-menu-ancestor")
    )) {
      if (el.id) {
        newEl = document.querySelector(`#${el.id}`);
        if (newEl !== null) {
          newEl.classList.add("current-menu-ancestor");
        }
      }
    }
  }

  triggerLinkAnchor() {
    if (window.location.hash) {
      const anchorId = window.location.hash;
      const anchorIdWithoutHash = anchorId.replace("#", "");
      const elementToScrollTo = document.getElementById(anchorIdWithoutHash);

      // Scroll to the link anchored element.
      elementToScrollTo.scrollIntoView({
        alignToTop: true,
        behavior: "smooth",
      });
    }
  }

  loadWysiwygVideoScripts() {
    if (window.wp) {
      // Remove existing script
      const existingScript = document.querySelector(
        'script[src="/wp-includes/js/mediaelement/mediaelement-and-player.js"]'
      );

      if (existingScript) {
        existingScript.remove();
      }
    }

    window.loadJS(
      "/wp-includes/js/mediaelement/mediaelement-and-player.js",
      () => {
        if (window.wp) {
          // Remove existing script
          const existingScript = document.querySelector(
            'script[src="/wp-includes/js/mediaelement/mediaelement-migrate.js"]'
          );
          if (existingScript) {
            existingScript.remove();
          }
        }
        window.loadJS(
          "/wp-includes/js/mediaelement/mediaelement-migrate.js",
          () => {
            if (window.wp) {
              // Remove existing script
              const existingScript = document.querySelector(
                'script[src="/wp-includes/js/mediaelement/wp-mediaelement.js"]'
              );
              if (existingScript) {
                existingScript.remove();
              }
            }
            window.loadJS(
              "/wp-includes/js/mediaelement/wp-mediaelement.js",
              () => {
                if (window.wp) {
                  // Remove existing script
                  const existingScript = document.querySelector(
                    'script[src="/wp-includes/js/mediaelement/renderers/vimeo.min.js"]'
                  );
                  if (existingScript) {
                    existingScript.remove();
                  }
                }
                window.loadJS(
                  "/wp-includes/js/mediaelement/renderers/vimeo.min.js",
                  () => {}
                );
              }
            );
          }
        );
      }
    );
  }

  fixWysiwyg() {
    const wpVideo = document.getElementsByClassName(".wp-video");

    if (wpVideo.length > 0) {
      if (undefined === window.jQuery) {
        window.loadJS("/wp-includes/js/jquery/jquery.min.js", () => {
          this.loadWysiwygVideoScripts();
        });
      } else {
        this.loadWysiwygVideoScripts();
      }

      if (undefined === window.wp) {
        window.loadCSS(
          "/wp-includes/js/mediaelement/mediaelementplayer-legacy.min.css",
          () => {}
        );
        window.loadCSS(
          "/wp-includes/js/mediaelement/wp-mediaelement.css",
          () => {}
        );
      }
    }
  }

  fixWpAdminBar() {
    if (!document.querySelector("#wpadminbar")) {
      return;
    }

    const xmlhttp = ajaxReq(); // eslint-disable-line
    const url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
    const params = `action=opa_fix_barbajs_wp_admin&location=${window.location.href}`;

    xmlhttp.open("POST", url, true); // set true for async, false for sync request
    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    xmlhttp.send(params); // or null, if no parameters are passed
    xmlhttp.onreadystatechange = () => {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        try {
          const response = JSON.parse(xmlhttp.responseText);
          if (response && response.success === true) {
            const adminMenuLinks = Array.from(
              document.querySelector(".ab-top-menu").querySelectorAll("a")
            );
            for (const adminLink of adminMenuLinks) {
              const mregex = /post=(\d+)&/g;
              adminLink.classList.add("js-barba-prevent");
              const href = adminLink.getAttribute("href");
              const groups = mregex.exec(href);
              if (groups && groups.length >= 2) {
                adminLink.setAttribute(
                  "href",
                  href.replace(groups[1], response.pageId)
                );
              } else {
                const chunks = href.split("?url=");
                const encodedWindowLocationHref = encodeURIComponent(
                  window.location.href
                );
                if (chunks.length === 2) {
                  adminLink.setAttribute(
                    "href",
                    `${chunks[0]}?url=${encodedWindowLocationHref}`
                  );
                }
              }
            }
          }
        } catch (error) {
          console.error(error); // eslint-disable-line no-console
        }
      }
    };
  }

  getMultiScripts(res, callback) {
    const newImports = [];
    const newEvaluations = [];
    const scriptTags = res.getElementsByTagName("script");

    Array.from(scriptTags).forEach((s, i) => {
      const src = s.getAttribute("src");
      if (src) {
        // If not already initialized add it
        if (
          window.initializedScripts.indexOf(src) === -1 &&
          window.previouslyLoadedScripts.indexOf(src) === -1
        ) {
          newImports.push(src);
        }
      } else {
        const scriptsNotAllowed = ["__bs_script__"]; // Scripts ID to not be loaded.
        const mimesNotAllowed = ["application/ld+json", "text/x-jsrender"]; // Scripts MIME Type to not be added.
        const scriptType = s.getAttribute("type");
        const scriptId = s.getAttribute("id");

        if (
          scriptsNotAllowed.indexOf(scriptId) === -1 &&
          mimesNotAllowed.indexOf(scriptType) === -1
        ) {
          newEvaluations.push(s.innerHTML);
        }
      }
    });

    function loadScript(url) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.src = url;
        script.async = false;
        script.onload = () => {
          resolve(url);
        };
        script.onerror = () => {
          reject(url);
        };
        document.body.appendChild(script);
        window.previouslyLoadedScripts.push(url);
      });
    }

    // Save all Promises as array
    const promises = [];
    newImports.forEach((url) => {
      promises.push(loadScript(url));
    });

    Promise.all(promises)
      .then(() => {
        // First eval load inline scripts.
        if (newEvaluations.length > 0) {
          newEvaluations.forEach((s) => {
            window.eval(`${s}`); //eslint-disable-line
          });
        }
        callback();
      })
      .catch((script) => {
        console.error(`${script} failed to load`); // eslint-disable-line
      });
  }

  getMultiStyles(res) {
    const newImports = [];
    const stylesTags = res.querySelectorAll('link[rel^="stylesheet"]');
    Array.from(stylesTags).forEach((s, i) => {
      const href = s.getAttribute("href");
      if (href) {
        // if not already initialized add it
        if (window.initializedStyles.indexOf(href) === -1) {
          newImports.push(href);
        }
      }
    });
    const loadStyle = () => {
      if (newImports.length > 0) {
        const nextStyle = newImports.shift();
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.onload = () => {
          loadStyle();
        };
        link.href = nextStyle;
        const headScript = document.querySelector("script");
        headScript.parentNode.insertBefore(link, headScript);
      }
    };

    loadStyle();
  }

  getStylesAndScripts(data, callback) {
    // Convert HTML Raw data to HTML Element in order to parser it.
    const response = data.next.html.replace(
      /(<\/?)body( .+?)?>/gi,
      "$1notbody$2>",
      data.next.html
    );
    const parser = new DOMParser();
    const res = parser.parseFromString(response, "text/html");

    // Identify and load scripts and styles for the next page.
    this.getMultiScripts(res, callback);
    this.getMultiStyles(res);
  }

  domReloadEvents() {
    const loadEvent = document.createEvent("Event");

    // Trigger DOMContentLoaded event
    window.document.dispatchEvent(
      new Event("DOMContentLoaded", {
        bubbles: true,
        cancelable: true,
      })
    );

    // Trigger load event
    loadEvent.initEvent("load", false, false);
    window.dispatchEvent(loadEvent);
  }
}

export default Barba;
